import { AccountAddress } from "@aptos-labs/ts-sdk";
import { getPrimarySubaccountAddr, UserOwnedVault, Vault } from "@decibeltrade/sdk";

import { sdkConfig } from "@/contexts/dex-sdk";

import { WithSubaccount } from "./types";

export const getVaultSubaccountAddress = (vaultAddress: string) => {
  return getPrimarySubaccountAddr(
    AccountAddress.from(vaultAddress),
    sdkConfig.compatVersion,
    sdkConfig.deployment.package,
  );
};

export const addSubaccountAddressToVault = <T extends Vault | UserOwnedVault>(vault: T) => {
  const vaultWithSubaccountAddress: WithSubaccount<T> = {
    ...vault,
    subaccount_address: getVaultSubaccountAddress(
      "vault_address" in vault ? vault.vault_address : vault.address,
    ),
  };

  return vaultWithSubaccountAddress;
};
